export default {
    communicationAutomationJobs: [],
    communications: [],
    leadIds: [],
    taskEvents: [],
};
